import api from "./api";

let profileCache = null;
let profilePromise = null;
const profileListeners = new Set();

const notifyProfileListeners = () => {
  profileListeners.forEach((listener) => {
    try {
      listener(profileCache);
    } catch {}
  });
};

export const getProfileCached = async (force = false) => {
  if (!force && profileCache) {
    return { data: profileCache };
  }

  if (!force && profilePromise) {
    return profilePromise;
  }

  profilePromise = api.get("/user/profile")
    .then((res) => {
      profileCache = res.data || {};
      notifyProfileListeners();
      return res;
    })
    .finally(() => {
      profilePromise = null;
    });

  return profilePromise;
};

export const updateProfileCache = (data) => {
  profileCache = data ? { ...(profileCache || {}), ...data } : null;
  notifyProfileListeners();
};

export const clearProfileCache = () => {
  profileCache = null;
  profilePromise = null;
  notifyProfileListeners();
};

export const subscribeProfileCache = (listener) => {
  if (typeof listener !== "function") return () => {};
  profileListeners.add(listener);
  return () => {
    profileListeners.delete(listener);
  };
};

export const uploadProfileImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);
  return api.post("/user/profile-image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
